import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../components/Spinner';
import {StyledComponentLoading} from './StyledComponentLoading';


const ComponentLoading = ({image, ...rest}) => (
  <StyledComponentLoading {...rest}>
    <Spinner size='small' image={image} />
  </StyledComponentLoading>
);


ComponentLoading.propTypes = {
  /** The image for loader */
  image: PropTypes.string,
};

export default ComponentLoading;
